export default __webpack_public_path__ + "static/media/Home-foto-header-incoming-Tower-viajes-desk.4b6d2c93.jpg";